define('modules/lp_info/views/main',['require','exports','module','base/layout','lib/util','env','backbone','backbone','underscore','common/views/alert_view','modules/page_listing/models/page_update','../models/variant','./variant_chart','./variant_list','./change_url_popup','common/views/confirmation_popup','modules/page_listing/views/tags_view','./edit_variant_popup','modules/page_listing/views/add_tag_popup','common/models/appstate','common/collections/domains','common/views/trial_expiration_popup','common/views/datepicker','./navigation','../../page_listing/views/copy_to_account_popup','../../page_listing/collections/pages','ldsh!../templates/layout'],function (require, exports, module) {
  'use strict';

  const Layout = require('base/layout'),
    util = require('lib/util'),
    config = require('env'),
    Backbone = require('backbone'),
    history = require('backbone').history,
    _ = require('underscore'),
    AlertView = require('common/views/alert_view'),
    PageUpdateCommand = require('modules/page_listing/models/page_update'),
    Variant = require('../models/variant'),
    VariantChart = require('./variant_chart'),
    VariantListView = require('./variant_list'),
    ChangeURLPopup = require('./change_url_popup'),
    ConfirmationPopup = require('common/views/confirmation_popup'),
    PageTagListView = require('modules/page_listing/views/tags_view'),
    EditVariantPopup = require('./edit_variant_popup'),
    AddTagPopup = require('modules/page_listing/views/add_tag_popup'),
    AppState = require('common/models/appstate'),
    DomainsCollection = require('common/collections/domains'),
    TrialExpirationPopup = require('common/views/trial_expiration_popup'),
    Datepicker = require('common/views/datepicker'),
    NavigationView = require('./navigation'),
    CopyToAccountPopup = require('../../page_listing/views/copy_to_account_popup'),
    PagesCollection = require('../../page_listing/collections/pages');

  const entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  var Controller = {
    resetStats: function (e) {
      e.preventDefault();
      const self = this;
      const variants = this.viewModel.get('variants');

      variants.each(function (variant) {
        variant.save(
          {
            visits: 0,
            visitors: 0,
            conversion: 0,
          },
          {
            patch: true,
          }
        );
      });

      //reset the page itself
      this.model.save(
        {
          visits: 0,
          visitors: 0,
          conversion: 0,
        },
        {
          patch: true,
          success: function () {
            self.showAlert($.i18n.t('landingPage.action.landingResetOk'), true);
            variants.fetch({ reset: true });
          },
        }
      );
    },

    deleteLP: function () {
      const page = this.model,
        self = this;

      if (config.avoidConfirmMessages) {
        return self.destroyPage(page);
      }

      ConfirmationPopup.show({
        title: $.i18n.t('pageListing.dialog.delete.title'),
        message: $.i18n.t('pageListing.dialog.delete.confirm').replace('{0}', page.get('name')),
      }).then(function () {
        self.destroyPage(page);
      });
    },

    destroyPage: function (page) {
      page.once(
        'sync',
        _.bind(Backbone.history.navigate, Backbone.history, '/pages', {
          trigger: true,
        })
      );
      page.destroy();

      return true;
    },

    _toggleLPForm: function (show) {
      this.$('.js-name-display').toggle(!show);
      this.$('.js-name-form').toggle(show);
      if (show) {
        this._hideErrorTooltip();
      }
    },

    _displayErrorTooltip: function (text) {
      this.$('.js-name-form').addClass('has-error');
      this.$('.js-name-error').html(text);
      this.$('.js-name-error').removeClass('hidden');
    },

    _hideErrorTooltip: function () {
      this.$('.js-name-form').removeClass('has-error');
      this.$('.js-name-error').addClass('hidden');
    },

    _displayTrialNotification: function () {
      TrialExpirationPopup.show();
    },

    addTag: function (e) {
      e.preventDefault();
      AddTagPopup.show(this.model);
    },

    copyPage: function () {
      CopyToAccountPopup.show().then(
        _.bind(function (companyId) {
          const pagesCollection = new PagesCollection({ paginationIsNeeded: false });
          pagesCollection.duplicatePage(
            this.model,
            { companyId: companyId },
            _.bind(this._notifyDuplicated, this)
          );
        }, this)
      );
    },

    _notifyDuplicated: function () {
      const message = $.i18n.t('pageListing.notifications.landingDuplicated');
      this.showAlert(message, true);
      window.scrollTo(0, 0);
    },

    editLPName: function () {
      this._toggleLPForm(true);
      this.$('.js-name').val(this.model.get('name'));
      this.$('.ed-title-bar').addClass('ed-title-bar--edit');
    },

    cancelLPName: function () {
      this._toggleLPForm(false);
      this.$('.ed-title-bar').removeClass('ed-title-bar--edit');
    },

    saveLPName: function (e) {
      const self = this,
        name = this.$('.js-name').val().trim();

      e.preventDefault();
      if (name.length > 0) {
        //avoid re-render
        this.stopListening(this.model, 'change');
        this.model.save(
          { name: name },
          {
            patch: true,
            error: function (model, response) {
              if (response.status === 406) {
                //name conflict
                self._displayErrorTooltip($.i18n.t('landingPage.nameForm.nameExists'));
              }
            },
            success: function () {
              self._hideErrorTooltip();
              self._toggleLPForm(false);
              self.render();
            },
          }
        );
        //reattach change listener
        this.listenTo(this.model, 'change', this.render);
      } else {
        self._displayErrorTooltip($.i18n.t('landingPage.nameForm.nameRequired'));
      }
    },

    publishLP: function () {
      if (AppState.hasExpired()) return this._displayTrialNotification();

      const self = this;
      const errorMessage = $.i18n.t('pageListing.notifications.landingError');
      const publishMessage = $.i18n.t('pageListing.notifications.landingPublished');
      const tags = this.model.tags.toJSON();

      this.model.save(
        { published: true },
        {
          patch: true,
          success: function () {
            self.showAlert(publishMessage, true);
            self.model.tags.reset(tags);
          },
          error: function () {
            self.model.set('published', false);
            self.showAlert(errorMessage, false);
          },
        }
      );
    },

    updateLP: function () {
      const self = this;
      const errorMessage = $.i18n.t('pageListing.notifications.landingError');
      const message = $.i18n.t('pageListing.notifications.landingUpdated');
      const updateCommand = new PageUpdateCommand({}, { pageId: this.model.id });

      updateCommand.save(null, {
        success: function () {
          self.showAlert(message, true);
          self.model.set('outdated', false);
        },
        error: function () {
          self.showAlert(errorMessage, false);
        },
      });
    },

    unpublishLP: function () {
      const self = this;
      const errorMessage = $.i18n.t('pageListing.notifications.landingError');
      const unpublishMessage = $.i18n.t('pageListing.notifications.landingUnpublished');
      const tags = this.model.tags.toJSON();

      this.model.save(
        { published: false },
        {
          patch: true,
          success: function () {
            self.showAlert(unpublishMessage, true);
            self.model.tags.reset(tags);
          },
          error: function () {
            self.model.set('published', true);
            self.showAlert(errorMessage, false);
          },
        }
      );
    },

    toggleVisibility: function () {
      const hidden = this.model.get('hidden');
      const successMessage = $.i18n.t('pageListing.notifications.landingHidden');
      const errorMessage = $.i18n.t('pageListing.notifications.landingError');

      this.model.save(
        { hidden: !hidden },
        {
          patch: true,
          success: _.bind(this.showAlert, this, successMessage),
          error: _.bind(function () {
            this.model.set('hidden', hidden);
            this.showAlert(errorMessage, false);
          }, this),
        }
      );
    },

    showAlert: function (message, isSuccess, options) {
      const alertOptions = options || {};

      alertOptions.message = message;
      alertOptions.alertType = isSuccess ? 'success' : 'danger';

      AlertView.showAlert(alertOptions);
    },
  };

  module.exports = Layout.extend({
    initialize: function (options) {
      this.i18n = {
        mainTitle: $.i18n.t('landingPage.mainVariants'),
        variantsTitle: $.i18n.t('landingPage.nonMainVariants'),
        discardedTitle: $.i18n.t('landingPage.discardedVariants'),
      };
      this.domains = new DomainsCollection();
      this.viewModel = new Backbone.Model();
      this.viewModel.set({
        variants: options.variants,
      });
      this.$mainVariant.show(
        new VariantListView({
          collection: this.viewModel.get('variants'),
          page: this.model,
          title: this.i18n.mainTitle,
          filter: { is_main: true },
        })
      );
      this.$activeVariants.show(
        new VariantListView({
          collection: this.viewModel.get('variants'),
          page: this.model,
          title: this.i18n.variantsTitle,
          filter: { active: true, is_main: false },
        })
      );
      this.$discardedVariants.show(
        new VariantListView({
          collection: this.viewModel.get('variants'),
          page: this.model,
          title: this.i18n.discardedTitle,
          filter: { active: false, is_main: false },
        })
      );
      this.$chart.show(
        new VariantChart({
          collection: this.viewModel.get('variants'),
        })
      );
      this.$tagList.show(new PageTagListView({ collection: this.model.tags }));

      const navigationView = new NavigationView();
      this.$navigation.show(navigationView);
      this.$datepicker.show(
        new Datepicker({
          model: options.variants.viewModel.get('date'),
          className: 'ed-stats-dateFilter hidden',
          noButton: true,
          noLabel: true,
          viewToggler: navigationView,
        })
      );

      this.listenTo(
        this.viewModel.get('variants'),
        'sync change add remove',
        _.bind(function () {
          var newStats = this.viewModel.get('variants').getStats();
          this.model.set('stats', newStats);
          this.showBlankHelp();
        }, this)
      );

      this.onRender = this.showBlankHelp;
    },

    template: require('ldsh!../templates/layout'),

    regions: {
      chart: '.js-variant-chart',
      tagList: '.js-tag-list',
      navigation: '.js-navigation',
      datepicker: '.js-datepicker-region',
      mainVariant: '.js-main-variant-region',
      activeVariants: '.js-active-variants-region',
      discardedVariants: '.js-discarded-variants-region',
    },

    events: {
      'click .js-reset': 'resetStats',
      'click .js-delete': 'deleteLP',
      'click .js-edit-name': 'editLPName',
      'click .js-save-name': 'saveLPName',
      'click .js-cancel-name': 'cancelLPName',
      'click .js-publish': 'publishLP',
      'click .js-update': 'updateLP',
      'click .js-unpublish': 'unpublishLP',
      'click .js-change-url': 'editUrl',
      'click .js-tag': 'addTag',
      'click .js-copy-to': 'copyPage',
      'click .js-hide': 'toggleVisibility',
      'click .js-display': 'toggleVisibility',
      'click .js-back': 'goBack',
    },

    helpers: function () {
      var safeName = escapeHtml(this.model.get('name'));
      var fullUrl = this.model.get('full_url');

      if (safeName.length > 100) {
        safeName = safeName.substr(0, 99) + '...';
      }

      if (fullUrl.indexOf('//') === 0) {
        fullUrl = 'https:' + fullUrl;
      }

      return {
        escapedName: safeName,
        fullUrl: fullUrl,
        showAMPByCompany: util.showAMPByCompany(),
        isNewFree: AppState.isAdminFreemium(),
      };
    },

    goBack: function () {
      document.querySelector('.ed-subnav').classList.remove('hidden');
      history.navigate('/pages', {
        replace: true,
        trigger: true,
      });
    },

    showBlankHelp: function () {
      const $blankHelp = this.$('.js-blank-help');
      const activeCount = this.viewModel.get('variants').getNonMainCount();
      const discardedCount = this.viewModel.get('variants').getDiscardedCount();

      $blankHelp.toggle(activeCount === 0);
      this.$('.js-active-variants-region').toggle(activeCount > 0);
      this.$('.js-discarded-variants-region').toggle(discardedCount > 0);
      this.$el.i18n();
    },

    editUrl: function (e) {
      e.preventDefault();
      const self = this;
      const page = this.model;

      this.domains.fetch();

      const changeURLPromise = function () {
        return ChangeURLPopup.show(page, self.domains)
          .then(function (data) {
            page.save(data, {
              patch: true,
              success: function () {
                $('.js-cancel').trigger('click');
              },
              error: function () {
                const errorMessage = $.i18n.t('landingPage.action.changeURLError');
                self.showAlert(errorMessage, false);
                changeURLPromise();
              },
              wait: true,
            });
          })
          .always(
            _.bind(Backbone.history.navigate, Backbone.history, '/info/' + self.model.id, {
              trigger: true,
            })
          );
      };
      changeURLPromise();
    },

    createVariant: function (mode) {
      const variants = this.viewModel.get('variants');

      variants.onReady(function () {
        const variant = new Variant({ mode: mode, name: this.model.get('name') });
        const page = this.model;
        const self = this;

        EditVariantPopup.show(variant, variants)
          .then(function (data) {
            //if there's no main for the platform, set weight as 100
            if (!variants.getMainFor(mode)) {
              variant.set({ weight: 100 });
            }

            if (data.crossPlatform) {
              const currentPlatform = self.getCurrentPlatform();

              variant.set('platform', mode);
              variant.set('mode', currentPlatform);
            }

            variants.add(variant);
            variant.save(data, { patch: true }).then(function () {
              if (!data.crossPlatform) return;
              //Adjust geometry property group width with mobile one
              const meta = variant.get('meta');
              const geo = meta && meta.properties[0];

              if (geo) {
                geo.width = variant.get('platform') === 'desktop' ? '1024' : '320';
                variant.save(
                  {
                    meta: meta,
                  },
                  { patch: true }
                );
              }
            });
          })
          .fail(function () {
            variants.remove(variant);
          })
          .always(function () {
            Backbone.history.navigate('/info/' + page.id, { trigger: true });
          });
      }, this);
    },

    getCurrentPlatform: function () {
      const variants = this.viewModel.get('variants');

      return variants.models[0].get('platform');
    },
  });

  util.mixin(module.exports, Controller);
});

